export default __webpack_public_path__ + "static/media/Formulario_COT.1c7a5be2.pdf";